<template>
    <v-container class="pa-0 ma-0" id="mainhomecontainer" >
         <v-card  class="overview" elevation=0 >
            <v-card-title class="pa-0">
              
               
              
                    <v-img  :src="(business.overviewimage=='' || business.overviewimage==null  )?bannerImg:business.overviewimage " aspect-ratio="1" class="" max-height="287">
                            <v-row class="fill-height align-center" style="background:rgba(0,0,0, 0.4);">
                                <v-col cols="12" md="12" sm="12" class="text-center white--text">
                                    <div v-if="business.overviewimagetitle=='' || business.overviewimagetitle==null">
                                        <h2 class="heading" >{{business.businessName}}</h2>
                                        <span class="subtitle-1">{{business.addressLine3}} {{business.addressLine4}}</span>

                                        <v-row justify="center">
                                        
                                            <v-col cols="12" md="12" sm="12"  align="center" class="text-center">
                                                <v-icon v-for="n in business.starrating" :key="n" color="#FEC83D" >mdi-star</v-icon>
                                                            
                                            </v-col>
                                        
                                        </v-row>
                                    </div>    
                                   <div v-else>
                                       <h2 class="heading" >{{business.overviewimagetitle}}</h2>
                                        <span class="subtitle-1 pl-3 pr-3">{{business.overviewimagedescription}} </span>
                                   </div>
                                </v-col>
                                
                            </v-row>
                           
                    </v-img>
                        
                    
            </v-card-title>

            <v-card-text class="mb-auto pwa-content pa-0">

                <v-tabs background-color="transparent" color="#FE5800" grow>

                    <v-tab href="#tab-overview" key="1" span class="white--text">Overview</span></v-tab>
                    <v-tab href="#tab-contacts" key="2"><span class="white--text">Contacts</span></v-tab>
                    <v-tab href="#tab-hours" key="3"><span class="white--text">Hours</span></v-tab>

                    <v-tab-item class="pb-80" key="1" value="tab-overview">
                        <v-container fluid>
                            <v-row>
                                <v-col cols="12" md="12" sm="12">
                                    <h1 class="mb-2" v-if="business.businessName!='null' && business.businessName!=''">{{business.businessName}}</h1>
                                    <h2 class="font-weight-regular subtitle-1">
                                        <span v-if="business.addressLine3!='null' && business.addressLine3!='' && business.addressLine3!=null">{{business.addressLine3}}</span> <span v-if="business.addressLine4!='null' && business.addressLine4!='' && business.addressLine4!=null">{{' '+business.addressLine4}}</span></h2>

                                    <v-row>
                                        
                                            <v-col cols="12" md="12" sm="12">
                                                <v-icon v-for="n in business.starrating" :key="n" color="#F39862" dense>mdi-star</v-icon>
                                                            
                                            </v-col>
                                        
                                    </v-row>

                                    
                                    <v-row v-if="business.description!='' && business.description!='null' && business.description!=null">
                                        <v-col cols="12" md="12" sm="12" class="pt-0" :class="{shortdesc:!longdesc}"  v-html="business.description" ></v-col> 

                                        <v-col cols="12" md="12" sm="12" class="pt-0 pb-0" >
                                            <a @click="longdesc=!longdesc" class="btn-read-more"><span v-if="!longdesc">Read More</span><span v-if="longdesc">Show Less</span></a>
                                        </v-col>

                                        
                                    </v-row>
                                    
                                    <!--<v-row v-if="business.facilities.length>0">

                                        <v-col cols="12" md="12" sm="12">
                                            <h3 class="mt-2 mb-2">Facilities</h3>
                                             <v-slide-group multiple >
                                                <v-slide-item
                                                    v-for="(item,index) in business.facilities" :key="index">
                                                <v-btn class="f-btn mr-1 mb-2 pt-1 pb-1" height="auto" small  elevation="0">
                                                
                                                   
                                                    <v-icon class="mb-1"  @click.stop="dialog = true" @click="setItem(item.facility,item.description)">{{item.icon}}</v-icon>

                                                       
                                                
                                                </v-btn>
                                                </v-slide-item>
                                            </v-slide-group>
                                           
                                        </v-col>
                                    </v-row>

                                    <v-dialog v-model="dialog"  max-width="800px">
                                       
                                        <v-card>
                                            <v-card-title >
                                                <span class="headline">{{facilitiyTitle}}</span>
                                                <v-spacer></v-spacer>
                                                <v-btn text icon color="red darken-1"  @click="dialog = false">
                                                    <v-icon>mdi-close-circle</v-icon>
                                                </v-btn>
                                            </v-card-title>

                                            <v-card-text v-if="facilityDesc!=''">
                                                <v-row>
                                                    <v-col cols="12" md="12" sm="12">
                                                        {{facilityDesc}}
                                                    </v-col>
                                                </v-row>
                                            </v-card-text>

                                            
                                        </v-card>    

                                    </v-dialog>


                                    
                                    <v-row class="mb-3" v-if="business.bgallery.length>0">

                                        <v-col cols="12" sm="12" md="12">
                                            <h3 class="mt-2 mb-2">Gallery</h3>
                                        </v-col>
                                        <v-col cols="4" sm="4" md="4" v-for="(item,index) in business.bgallery" :key="index" class="mb-1 pa-0 pr-1">
                                           
                                             <v-img :src="item.imageurl" width="150" height="150" class="mr-1 " @click="openslideshow(index)"></v-img>
                                        </v-col>
                                       
                                        
                                    </v-row>  -->


                                
                                    
                                </v-col>
                            </v-row>

                            

                           
                            

                            
                            <v-row>
                                <v-col cols="6" md="6" class="text-center">
                                    <v-btn class="primary" @click="leave">Leave Business</v-btn>
                                </v-col>
                                <v-col cols="6" md="6" class="text-center">
                                    <v-btn class="primary" >Review Business</v-btn>
                                </v-col>
                                
                            </v-row>
                            <!-- <v-dialog v-model="dialoggl" max-width="100%">
                                        <v-carousel hide-delimiters>
                                                <v-carousel-item
                                                v-for="(item,i) in items"
                                                :key="i"
                                                :src="item.src"
                                            ></v-carousel-item>
                                        </v-carousel>
                            </v-dialog> -->
                        </v-container>
                    </v-tab-item>
                    <v-tab-item class="pb-80" key="2" value="tab-contacts">
                        <v-container fluid>
                            <v-row>
                                <v-col>
                                    <v-card class="mb-5"> 
                                        <v-card-text class="pt-0 pb-0">
                                            <v-row>
                                                <v-col cols="3" md="3" sm="3">
                                                    <v-avatar>
                                                        <img v-if="business.conimgthumb!=''" :src="business.conimgthumb" />
                                                    </v-avatar>
                                                </v-col>
                                                <v-col cols="9" md="9" sm="9">
                                                    <div class="title" v-if="business.contactName">{{business.contactName}}</div>
                                                    <div class="subtitle-1" v-if="business.contactPosition">{{business.contactPosition}}</div>
                                                </v-col>
                                            </v-row>
                                        </v-card-text>
                                    </v-card>
                                    <v-card class=" mb-5" v-if="business.phone!='' && business.phone!='null' && business.phone!=null">
                                        <v-card-text class="pt-0 pb-0" style="padding-left:12px;">
                                            <v-row align="center" >
                                                <v-col cols="2" md="2" sm="2" class="" align="center" style="background:rgba(183, 199, 205, 0.5);">
                                                    
                                                  <v-icon size="32" >mdi-phone-in-talk</v-icon>
                                                    
                                                </v-col>
                                                <v-col cols="10" md="10" sm="10" class="pt-0 pb-0">
                                                    <div color="#7697A1" class="body-1">
                                                       
                                                        <a :href="'tel:'+business.phone.replace(/\s/g,'').trim()">{{business.phone}}</a>
                                                    </div>
                                                    
                                                </v-col>
                                            </v-row>
                                        </v-card-text>
                                    </v-card>

                                    <v-card class="mb-5" v-if="(business.whatsapp!=null && business.whatsapp!='null' && business.whatsapp!='')">
                                        <v-card-text class="pt-0 pb-0" style="padding-left:12px;">
                                            <v-row align="center">
                                                <v-col cols="2" md="2" sm="2" class="" align="center" style="background:rgba(183, 199, 205, 0.5);">
                                                    
                                                  <v-icon size="32" >mdi-whatsapp</v-icon>
                                                    
                                                </v-col>
                                                <v-col cols="10" md="10" sm="10" class="pt-0 pb-0">
                                                    <div color="#7697A1" class="body-1">
                                                        

                                                        <a :href="'https://api.whatsapp.com/send?phone='+business.whatsapp.replace(/\s/g,'').trim()+'&text='+business.whatsapmsg">{{business.whatsapp}}</a>
                                                    
                                                    </div>
                                                    
                                                </v-col>
                                            </v-row>
                                        </v-card-text>
                                    </v-card>

                                    <v-card class="mb-5" v-if="(business.addressline1!=null && business.addressline1!='null') || (business.addressline2!=null && business.addressline2!='null') || (business.addressline3!=null && business.addressline3!='null') || (business.addressline4!=null && business.addressline4!='null') || (business.addressline5!=null && business.addressline5!='null')">
                                        <v-card-text class="pt-0 pb-0" style="padding-left:12px;">
                                            <v-row align="center">
                                                <v-col cols="2" md="2" sm="2" class="" align="center" style="background:rgba(183, 199, 205, 0.5);">
                                                    
                                                  <v-icon size="32" >mdi-map-marker</v-icon>
                                                    
                                                </v-col>
                                                <v-col cols="10" md="10" sm="10" class="pt-0 pb-0">
                                                    <div color="#7697A1" class="body-1">
                                                        <span v-if="(business.addressline1!=null && business.addressline1!='null') ">{{business.addressline1}} </span>
                                                        <span v-if="(business.addressline2!=null && business.addressline2!='null')">{{business.addressline2}}</span>
                                                        <span v-if="(business.addressline3!=null && business.addressline3!='null') ">{{business.addressLine3}} </span>
                                                        <span v-if="(business.addressline4!=null && business.addressline4!='null') || (business.addressline5!=null && business.addressline5!='null')">{{business.addressLine4}} </span>
                                                        <span v-if="(business.addressline5!=null && business.addressline5!='null')">{{business.addressline5}} </span>
                                                        <span v-if="business.postcode"> {{business.postcode}}</span>
                                                        <span v-if="business.country"> {{business.country}}</span></div>
                                                    
                                                </v-col>
                                            </v-row>
                                        </v-card-text>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-tab-item> 
                    <v-tab-item class="pb-80" key="3" value="tab-hours">
                        <v-container fluid>
                            <v-row>
                               <v-col cols="12" md="12" sm="12">
                                    <h1 class="mb-2">Hours</h1>
                                    <span v-if="business.openinghoursother!=''">{{business.openinghoursother}}</span>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12" md="12" sm="12">
                                    <v-simple-table>
                                        <template v-slot:default>
                                            
                                            <tbody>
                                                <tr>
                                                    <td class="pl-2 pr-0 " width="85">Monday</td>

                                                    <td class="pl-0 pr-0 " width="40"><v-icon>mdi-clock</v-icon></td>
                                                    
                                                    <td class="pl-0 pr-0 " >
                                                        <span v-if="(business.mondayopening!=0 && business.mondayclosing!=0)  && (business.mondayopening!='allwaysopen' && business.mondayclosing!='allwaysopen')">
                                                        {{business.mondayopening}} - {{business.mondayclosing}} </span>
                                                        
                                                        <span v-else-if="(business.mondayopening=='allwaysopen' && business.mondayclosing=='allwaysopen')">Always Open</span>


                                                         <span v-else style="color:#fe5800">Closed</span>
                                                        
                                                        </td>

                                                    <td class="pl-0 pr-0"  width="30"><span v-if="(business.mondayopening2!=0 && business.mondayclosing2!=0) && (business.mondayopening2!='allwaysopen' && business.mondayclosing2!='allwaysopen') && (business.mondayopening2!=null && business.mondayclosing2!=null) && (business.mondayopening2!='null' && business.mondayclosing2!='null')">&</span></td>
                                                    
                                                    <td class="pl-0 pr-0 " >
                                                        <span v-if="(business.mondayopening2!=0 && business.mondayclosing2!=0) && (business.mondayopening2!='allwaysopen' && business.mondayclosing2!='allwaysopen') && (business.mondayopening2!=null && business.mondayclosing2!=null) && (business.mondayopening2!='null' && business.mondayclosing2!='null')">
                                                            {{business.mondayopening2}} - {{business.mondayclosing2}}
                                                        </span>
                                                    </td>
                                                </tr>

                                                <tr style="background:#F6F7F8;">
                                                    <td class="pl-2 pr-0 ">Tuesday</td>
                                                    
                                                    <td class="pl-0 pr-0 " ><v-icon>mdi-clock</v-icon></td>

                                                    <td class="pl-0 pr-0 ">
                                                        <span v-if="(business.tuesdayopening!=0 && business.tuesdayclosing!=0) && (business.tuesdayopening!='allwaysopen' && business.tuesdayclosing!='allwaysopen')">{{business.tuesdayopening}} - {{business.tuesdayclosing}} </span>
                                                    
                                                        <span v-else-if="(business.tuesdayopening=='allwaysopen' && business.tuesdayclosing=='allwaysopen')">Always Open</span>

                                                        <span v-else style="color:#fe5800">
                                                            Closed
                                                        </span>
                                                    </td>
                                                    
                                                    <td class="pl-0 pr-0 " ><span v-if="(business.tuesdayopening2!=0 && business.tuesdayclosing2!=0) && (business.tuesdayopening2!='allwaysopen' && business.tuesdayclosing2!='allwaysopen') && (business.tuesdayopening2!=null && business.tuesdayclosing2!=null) && (business.tuesdayopening2!='null' && business.tuesdayclosing2!='null')">&</span></td>

                                                    <td class="pl-0 pr-0 " >
                                                        <span v-if="(business.tuesdayopening2!=0 && business.tuesdayclosing2!=0) && (business.tuesdayopening2!='allwaysopen' && business.tuesdayclosing2!='allwaysopen') && (business.tuesdayopening2!=null && business.tuesdayclosing2!=null) && (business.tuesdayopening2!='null' && business.tuesdayclosing2!='null')">
                                                            {{business.tuesdayopening2}} - {{business.tuesdayclosing2}}
                                                        </span>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td class="pl-2 pr-0 ">Wednesday</td>

                                                    <td class="pl-0 pr-0 " ><v-icon>mdi-clock</v-icon></td>

                                                    <td class="pl-0 pr-0 ">
                                                        <span v-if="(business.wednesdayopening!=0 && business.wednesdayclosing!=0) && (business.wednesdayopening!='allwaysopen' && business.wednesdayclosing!='allwaysopen')">{{business.wednesdayopening}} - {{business.wednesdayclosing}} 
                                                        </span>

                                                        <span v-else-if="(business.wednesdayopening=='allwaysopen' && business.wednesdayclosing=='allwaysopen')">
                                                            Always Open
                                                        </span>

                                                        <span v-else style="color:#fe5800">Closed</span>
                                                    
                                                    </td>
                                                    
                                                    <td class="pl-0 pr-0 "><span v-if="(business.wednesdayopening2!=0 && business.wednesdayclosing2!=0) && (business.wednesdayopening2!='allwaysopen' && business.wednesdayclosing2!='allwaysopen') && (business.wednesdayopening2!=null && business.wednesdayclosing2!=null) && (business.wednesdayopening2!='null' && business.wednesdayclosing2!='null')">&</span></td>

                                                    <td class="pl-0 pr-0 ">
                                                        <span v-if="(business.wednesdayopening2!=0 && business.wednesdayclosing2!=0) && (business.wednesdayopening2!='allwaysopen' && business.wednesdayclosing2!='allwaysopen') && (business.wednesdayopening2!=null && business.wednesdayclosing2!=null) && (business.wednesdayopening2!='null' && business.wednesdayclosing2!='null')">
                                                            {{business.wednesdayopening2}} - {{business.wednesdayclosing2}}
                                                        </span>
                                                    </td>
                                                </tr>

                                                <tr style="background:#F6F7F8;">
                                                    <td class="pl-2 pr-0 " >Thursday</td>

                                                    <td class="pl-0 pr-0 " ><v-icon>mdi-clock</v-icon></td>

                                                    <td class="pl-0 pr-0 ">
                                                        <span v-if="(business.thursdayopening!=0 && business.thursdayclosing!=0) && (business.thursdayopening!='allwaysopen' && business.thursdayclosing!='allwaysopen')">{{business.thursdayopening}} - {{business.thursdayclosing}}</span> 
                                                    
                                                        <span v-else-if="(business.thursdayopening=='allwaysopen' && business.thursdayclosing=='allwaysopen')">
                                                            Always Open
                                                        </span>

                                                        <span v-else style="color:#fe5800">Closed</span>
                                                    </td>
                                                    
                                                    <td class="pl-0 pr-0 "><span v-if="(business.thursdayopening2!=0 && business.thursdayclosing2!=0) && (business.thursdayopening2!='allwaysopen' && business.thursdayclosing2!='allwaysopen') && (business.thursdayopening2!=null && business.thursdayclosing2!=null) && (business.thursdayopening2!='null' && business.thursdayclosing2!='null')">&</span></td>

                                                    <td class="pl-0 pr-0 ">
                                                        <span v-if="(business.thursdayopening2!=0 && business.thursdayclosing2!=0) && (business.thursdayopening2!='allwaysopen' && business.thursdayclosing2!='allwaysopen') && (business.thursdayopening2!=null && business.thursdayclosing2!=null) && (business.thursdayopening2!='null' && business.thursdayclosing2!='null')">
                                                            {{business.thursdayopening2}} - {{business.thursdayclosing2}}
                                                        </span>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td class="pl-2 pr-0 ">Friday</td>

                                                    <td class="pl-0 pr-0 " ><v-icon>mdi-clock</v-icon></td>

                                                    <td class="pl-0 pr-0 ">
                                                        <span v-if="(business.fridayopening!=0 && business.fridayclosing!=0) && (business.fridayopening!='allwaysopen' && business.fridayclosing!='allwaysopen')">
                                                             {{business.fridayopening}} - {{business.fridayclosing}} 
                                                        </span>

                                                         <span v-else-if="(business.fridayopening=='allwaysopen' && business.fridayclosing=='allwaysopen')">Always Open</span>

                                                         <span v-else style="color:#fe5800">Closed</span>

                                                    </td>
                                                    
                                                    <td class="pl-0 pr-0 ">
                                                        
                                                        <span v-if="(business.fridayopening2!=0 && business.fridayclosing2!=0) && (business.fridayopening2!='allwaysopen' && business.fridayclosing2!='allwaysopen') && (business.fridayopening2!=null && business.fridayclosing2!=null) && (business.fridayopening2!='null' && business.fridayclosing2!='null')">&</span>
                                                    
                                                    </td>

                                                    <td class="pl-0 pr-0 ">
                                                        <span v-if="(business.fridayopening2!=0 && business.fridayclosing2!=0) && (business.fridayopening2!='allwaysopen' && business.fridayclosing2!='allwaysopen') && (business.fridayopening2!=null && business.fridayclosing2!=null) && (business.fridayopening2!='null' && business.fridayclosing2!='null')">
                                                            {{business.fridayopening2}} - {{business.fridayclosing2}}
                                                        </span>
                                                    </td>
                                                </tr>

                                                <tr style="background:#F6F7F8;">
                                                    <td class="pl-2 pr-0 ">Saturday</td>

                                                    <td class="pl-0 pr-0 " ><v-icon>mdi-clock</v-icon></td>

                                                    <td class="pl-0 pr-0 ">
                                                        <span v-if="(business.saturdayopening!=0 && business.saturdayclosing!=0) && (business.saturdayopening!='allwaysopen' && business.saturdayclosing!='allwaysopen')">
                                                        {{business.saturdayopening}} - {{business.saturdayclosing}} </span>

                                                        <span v-else-if="(business.saturdayopening=='allwaysopen' && business.saturdayclosing=='allwaysopen')">
                                                            Always Open
                                                        </span>

                                                        <span v-else style="color:#fe5800">Closed</span>
                                                    
                                                    </td>
                                                    
                                                    <td class="pl-0 pr-0 " ><span v-if="(business.saturdayopening2!=0 && business.saturdayclosing2!=0) && (business.saturdayopening2!='allwaysopen' && business.saturdayclosing2!='allwaysopen') && (business.saturdayopening2!=null && business.saturdayclosing2!=null) && (business.saturdayopening2!='null' && business.saturdayclosing2!='null')">&</span></td>

                                                    <td class="pl-0 pr-0 " >
                                                      <span v-if="(business.saturdayopening2!=0 && business.saturdayclosing2!=0) && (business.saturdayopening2!='allwaysopen' && business.saturdayclosing2!='allwaysopen') && (business.saturdayopening2!=null && business.saturdayclosing2!=null) && (business.saturdayopening2!='null' && business.saturdayclosing2!='null')">  {{business.saturdayopening2}} - {{business.saturdayclosing2}}</span>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td class="pl-2 pr-0 " >Sunday</td>

                                                    <td class="pl-0 pr-0 " ><v-icon>mdi-clock</v-icon></td>

                                                    <td class="pl-0 pr-0 ">
                                                        <span v-if="(business.sundayopening!=0 && business.sundayclosing!=0) && (business.sundayopening!='allwaysopen' && business.sundayclosing!='allwaysopen')">
                                                            {{business.sundayopening}} - {{business.sundayclosing}} 
                                                        </span> 

                                                        <span v-else-if="(business.sundayopening=='allwaysopen' && business.sundayclosing=='allwaysopen')">
                                                            Always Open    
                                                        </span>   

                                                        <span v-else style="color:#fe5800">Closed</span>
                                                    </td>
                                                    
                                                    <td class="pl-0 pr-0 " ><span v-if="(business.sundayopening2!=0 && business.sundayclosing2!=0) &&  (business.sundayopening2!='allwaysopen' && business.sundayclosing2!='allwaysopen') && (business.sundayopening2!=null && business.sundayclosing2!=null) && (business.sundayopening2!='null' && business.sundayclosing2!='null')">&</span></td>

                                                    <td class="pl-0 pr-0 " >
                                                        <span v-if="(business.sundayopening2!=0 && business.sundayclosing2!=0) &&  (business.sundayopening2!='allwaysopen' && business.sundayclosing2!='allwaysopen') && (business.sundayopening2!=null && business.sundayclosing2!=null) && (business.sundayopening2!='null' && business.sundayclosing2!='null')">{{business.sundayopening2}} - {{business.sundayclosing2}}</span></td>

                                                   
                                                </tr>


                                            </tbody>

                                        </template>
                                    </v-simple-table>
                                </v-col>
                                
                                
                            </v-row>
                        </v-container>
                    </v-tab-item> 
                </v-tabs>
            </v-card-text>

            <!-- <v-card-text class="mb-auto  pa-0">
                    <v-container fluid>
                            <v-row>
                                <v-col cols="11" md="11" sm="11" class="text-center">
                                    <h1 class="mb-2" >Welcome</h1>
                                    <h2 class="font-weight-regular subtitle-1">
                                        <span v-if="$isloggedin">{{$user.name}}</span>
                                        <span v-else>Guest</span></h2>

                                    

                                    
                                </v-col>
                                <v-col cols="1" md="1" sm="1" v-if="$isloggedin">
                                    <v-btn color="error" text @click="logout">Logout</v-btn>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12" md="4" class="text-center">
                                    <v-btn class="primary" @click="leave">Leave Business</v-btn>
                                </v-col>
                                <v-col cols="12" md="4" class="text-center">
                                    <v-btn class="primary" @click="review">Review Business</v-btn>
                                </v-col>
                                <v-col cols="12" md="4" class="text-center">
                                    <v-btn class="primary">Business Details</v-btn>
                                </v-col>
                            </v-row>
                            
                        </v-container>
            </v-card-text> -->

         </v-card>
    </v-container>
</template>
<script>
import Vue from 'vue'
import moment from 'moment';
export default {
    props: {
    source: String
  },
   data: () => ({
      code:"",
      key:"",
      bannerImg:require('@/assets/overview-banner.jpg'),
      address:"",
      loading:false,
      business:[],
      visitid:'',
      type:'',
      longdesc:false,
      shortdesc:'',
  }),
   created() {
    //    if (this.$route.params.key) {
    //   this.key = this.$route.params.key;
    //    }
     if (this.$route.params.code) {
      this.code = this.$route.params.code;
      
        }
      if (this.$route.params.type) {
      this.type = this.$route.params.type;
      
        }   
    this.getBusiness();
  },
  methods:
   {
       leave()
       {
           this.$http
                    .get( this.$apidomain+"leavebusiness/" + this.visitid)
                    .then(res => {
                    this.businessvisit =res.data.businessvisit;
                    if(!this.$isloggedin)
                    {
                        this.$router.push("/login");
                    }else
                    {
                        //profile if login name,address edit
                    }
                    
                    })
                    .catch(err => {
                    console.log(err.response);
                    });
       },
       getBusiness() 
       {
        let url='';
           if(localStorage.getItem('isLoggedin')=='true')
           {
               url= this.$apidomain+"businessdatahome/" + this.code;
               if(this.type=='uc')
               {
                    url= this.$apidomain+"businessbycode/" + this.code;
                   
               }
                this.$http
                    .get( url)
                    .then(res => {
                    this.business =res.data.business;
                    this.visitid=this.business.uservisitid;
                    
                    this.loading=false;
                    })
                    .catch(err => {
                    console.log(err.response);
                    });
           }
           else{
               let url ='';
               if(this.type=='uc')
               {
                   if(this.getCookie('jzuserkey') && this.getCookie('jzuserkey')!='undefined'){
                   url=this.$apidomain+"businessbycode/" + this.code+ "/"+ this.getCookie('jzuserkey');
                   
                    }else{
                        url=this.$apidomain+"businessbycode/" + this.code;
                    }
               }
               else
               {
                   if(this.getCookie('jzuserkey') && this.getCookie('jzuserkey')!='undefined'){
                   url=this.$apidomain+"businessdataguest/" + this.code+ "/"+ this.getCookie('jzuserkey');
                   
                    }else{
                        url=this.$apidomain+"businessdataguest/" + this.code;
                    }

               }
               

               this.$http
                    .get( url)
                    .then(res => {
                    this.business =res.data.business;
                    this.setCookie('jzuserkey',this.business.notloggedinkey,1800);
                    this.visitid=this.business.uservisitid;     
                    this.loading=false;
                    })
                    .catch(err => {
                    console.log(err.response);
                    });
           }
        },
        logout() 
        {
            this.$store.dispatch("logout").then(() => {
            this.$router.push("/login");
            });
        },
        setCookie(cname, cvalue, exdays) 
        {
            var d = new Date();
            d.setTime(d.getTime() + (exdays*24*60*60*1000));
            var expires = "expires="+ d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        },
        getCookie(cname) 
        {
                var name = cname + "=";
                var decodedCookie = decodeURIComponent(document.cookie);
                var ca = decodedCookie.split(';');
                for(var i = 0; i <ca.length; i++) {
                    var c = ca[i];
                    while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                    }
                    if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                    }
                }
                return "";
        }
   }
}
</script>
<style scoped>
#mainhomecontainer.container{
    width: 100%;
    max-width:100%;
}
#mainhomecontainer.container .heading
{
    color: #fff;
    
}

.pwa-content{
    margin-top: -60px;
}
.f-btn .v-btn__content
{
    -webkit-box-orient: vertical;

-webkit-box-direction: reverse;

-ms-flex-direction: column-reverse;

flex-direction: column-reverse;
}
.mt-60-n{
    margin-top:-60px;
}
.pb-80{
    padding-bottom: 80px;
}
.v-card__title{
    word-break: normal;
}
.align-cnt
{
    text-align: center;
}
.btn-read-more,.v-application a.btn-read-more{
    padding: 5px;
    background: #ef5000;
    color: #fff !important;
    border-radius: 4px;
    margin-bottom: 1rem;
}
.overview .v-slide-group__prev {
        display: none;
    }
.overview .v-slide-group__next{
        display: none;
    }
.longdesc
{
    height: auto;
}
.shortdesc
{
    height:150px;
    overflow:hidden;
}
</style>